import {takeLatest} from 'redux-saga/effects';
/*CONSTANTS*/
import {
    BOOK_EVENT,
    DELETE_ALERT,
    DELETE_LIVE_SETTINGS,
    GET_EVENT,
    GET_EVENTS,
    GET_LIVE_EVENTS,
    GET_LIVE_ODDS_EVENTS,
    GET_LIVE_SETTINGS,
    HIDE_ALERT,
    LIVE_INITIALIZE,
    STORE_LIVE_INITIALIZE
} from '../../constants/LiveConstants';
/*SAGAS*/
import {getLiveEventsSaga} from './getLiveEventsSaga';
import {getLiveOddsEventsSaga} from './getLiveOddsEventsSaga';
import {getEventSaga} from "./getEventSaga";
import {bookLiveSaga} from "./bookLiveSaga";
import {storeSettingSaga} from "./storeSettingSaga";
import {hideAlertSaga} from "./hideAlertSaga";
import {getSettingSaga} from "./getSettingSaga";
import {deleteSettingSaga} from "./deleteSettingSaga";
import {getEventsSaga} from './getEventsSaga';
import {deleteAlertSaga} from './deleteAlert';
import {initializeLiveSaga} from './initializeLiveSaga';

export function* StoreSetting(): Generator {
    // @ts-ignore
    yield takeLatest(STORE_LIVE_INITIALIZE, storeSettingSaga);
}

export function* GetSetting(): Generator {
    // @ts-ignore
    yield takeLatest(GET_LIVE_SETTINGS, getSettingSaga);
}

export function* DeleteSetting(): Generator {
    // @ts-ignore
    yield takeLatest(DELETE_LIVE_SETTINGS, deleteSettingSaga);
}

export function* InitializeLive(): Generator {
    // @ts-ignore
    yield takeLatest(LIVE_INITIALIZE, initializeLiveSaga);
}

export function* GetMonitorEvents(): Generator {
    yield takeLatest(GET_LIVE_EVENTS, getLiveEventsSaga);
}

export function* GetMonitorOddsEvents(): Generator {
    yield takeLatest(GET_LIVE_ODDS_EVENTS, getLiveOddsEventsSaga);
}

export function* GetEvent(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENT, getEventSaga);
}

export function* BookEvent(): Generator {
    // @ts-ignore
    yield takeLatest(BOOK_EVENT, bookLiveSaga);
}

export function* DeleteAlert(): Generator {
    // @ts-ignore
    yield takeLatest(DELETE_ALERT, deleteAlertSaga);
}

export function* HideAlert(): Generator {
    // @ts-ignore
    yield takeLatest(HIDE_ALERT, hideAlertSaga);
}

export function* BookLive(): Generator {
    // @ts-ignore
    yield takeLatest(BOOK_EVENT, bookLiveSaga);
}

export function* GetEvents(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENTS, getEventsSaga);
}


